"use client";

import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./src/theme/theme";
import ReduxProvider from "./src/redux/store/reduxProvider";
import "./globals.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
export default function RootLayout({ children }) {
  return (
    <html lang="en">
      <head>
        {/* Favicon */}
        <link rel="icon" href="/logo/brand_logo.png" />
        <title>LXR Holdings Property management</title>
      </head>
      <body>
        <ReduxProvider>
          <ToastContainer
            position="top-right"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnHover
          />
          <ThemeProvider theme={theme}>
            <CssBaseline />
            {children}
          </ThemeProvider>
        </ReduxProvider>
      </body>
    </html>
  );
}
